import * as runtime from '@/api/runtime'
import {
  DeleteReserveGroupRequest,
  DeleteReserveGroupRequestToJSON,
  GetReserveGroupRequest,
  GetReserveGroupRequestToJSON,
  RegisterReserveGroupRequest,
  RegisterReserveGroupRequestToJSON,
  ReservationCandidateList,
  ReservationCandidateListFromJSON,
  ReserveGroup,
  ReserveGroupFromJSON,
  SearchReserveGroupRequest,
  SearchReserveGroupRequestToJSON,
  UpdateReserveGroupRequest,
  UpdateReserveGroupRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class ReserveGroupApi extends runtime.BaseAPI {
  /**
   * グループ予約候補リストを検索する
   * グループ予約候補リスト検索
   */
  async searchGroupReserve(
    request: SearchReserveGroupRequest
  ): Promise<ReservationCandidateList[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchReserveGroupRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/reserve-groups/search',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReservationCandidateListFromJSON)
    ).value()
  }

  /**
   * グループ予約候補リストを取得する
   * グループ予約候補リスト取得
   */
  async getGroupReserve(
    request: GetReserveGroupRequest
  ): Promise<ReserveGroup> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetReserveGroupRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/reserve-groups/${queryParameters?.id ?? ''}`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReserveGroupFromJSON(jsonValue)
    ).value()
  }

  /**
   * グループ予約候補リストを削除する
   * グループ予約候補リスト削除
   */
  async deleteGroupReserve(
    request: DeleteReserveGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteReserveGroupRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/reserve-groups/${bodyParameters?.id ?? ''}`
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * グループ予約候補リストを登録する
   * グループ予約候補リスト登録
   */
  async registerGroupReserve(
    request: RegisterReserveGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = RegisterReserveGroupRequestToJSON(
      request
    )
    const response = await this.requestPost('/reserve-groups', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * グループ予約候補リストを更新する
   * グループ予約候補リスト更新
   */
  async updateGroupReserve(
    request: UpdateReserveGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateReserveGroupRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/reserve-groups/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
